import { OohCourierTrip } from '../graphql/types';
import { useOohCourierTripsQuery } from '../graphql/Routes/OohCourierTrips.generated';

type OohCourierTripsResult = {
  areCourierTripsLoading: boolean;
  courierTrips: OohCourierTrip[];
};

const useOohCourierTripsDataStore = (
  date: string | null,
  routeId: string | null,
): OohCourierTripsResult => {
  const { loading, data } = useOohCourierTripsQuery({
    skip: !routeId || !date,
    variables:
      routeId && date
        ? {
            routeId,
            date,
          }
        : undefined,
  });

  if (data !== undefined) {
    return {
      courierTrips: data.OohCourierTrips,
      areCourierTripsLoading: loading,
    };
  }

  return {
    courierTrips: [],
    areCourierTripsLoading: loading,
  };
};

export default useOohCourierTripsDataStore;
